<script>
    import Fa from "svelte-fa";
    import {faCertificate, faCreditCard} from "@fortawesome/free-solid-svg-icons";

    /**
     * @typedef {Object} Props
     * @property {boolean} [showIcon]
     * @property {any} token
     * @property {any} [emptyIcon]
     * @property {string} [emptyLabel]
     */

    /** @type {Props} */
    let {
        showIcon = true,
        token,
        emptyIcon = faCreditCard,
        emptyLabel = ''
    } = $props();

    let icon = $derived(token ? (token.type === 'HW' ? faCreditCard : faCertificate) : emptyIcon);
    let label = $derived(token ? (token.customName ? token.subjectCommonName + ' | ' + token.customName : token.subjectCommonName) : emptyLabel);
</script>

{#if showIcon}
    <span class="token-icon"><Fa {icon} /></span>
{/if}
<span class="token-label">{label}</span>

<style>
    .token-icon {
        color: var(--brak-dark-blue);
        margin-right: 0.3em;
    }

    .token-label {
        font-weight: bold;
    }
</style>